import React from "react";
import { styled } from "../../stitches.config";
import Avatar from "../atoms/Avatar";
import DateBadge from "../atoms/DateBadge";
import { body } from "../commonStyles/Fonts";
import { h4Strong } from "../commonStyles/Fonts";
import { withThemeContext } from "./StitchesThemeProvider";

interface ColumnistProps {
  type?: "past" | "active" | "disabled" | "default";
  src: string;
  url: string;
  name: string;
  title: string;
  dateText?: string;
  dayText?: string;
  status?: string;
  blockStatus?: "active" | "inactive";
  article?: any,
  authorLink?: string;
  isDarkMode?: boolean;
}

const Columnist: React.FC<ColumnistProps> = ({
  type,
  src,
  name,
  title,
  dateText,
  dayText,
  url,
  status,
  blockStatus,
  article,
  authorLink,
  isDarkMode,
  ...props
}) => {

  const link = (article?.link ? article.link : url);

  return (
    <StyledColumnist className="columnist" type={type} blockStatus={blockStatus}>
      {blockStatus === "inactive" ?
        <div className="link-wrapper">
          <a href={authorLink}>
            <Avatar src={src} />
          </a>
          <a href={authorLink}><h4 className={h4Strong()}>{name}</h4></a>
          {title && <StyledColumnistTitle className={body()}>{title}</StyledColumnistTitle>}
          {article?.description && <StyledColumnistTitle className={body()}>{article.description}</StyledColumnistTitle>}
          {status === "archive" && (
            <DateBadge type="outline" dateText={dateText} dayText={dayText} />
          )}
          {status === "current" && (
            <DateBadge type="fill" dateText={dateText} dayText={dayText} />
          )}
          {status === "future" && (
            <DateBadge type="gray" dateText={dateText} dayText={dayText} />
          )}
        </div>
        :
        <a className={isDarkMode ? "link-wrapper" : "link-wrapper link-wrapper--active"} href={link}>
          {status === "current" ?
            <Avatar border={true} src={src} /> : <Avatar src={src} />
          }
          <h4 className={h4Strong()}>{name}</h4>
          {title && <StyledColumnistTitle className={body()}>{title}</StyledColumnistTitle>}
          {article?.description && <StyledColumnistTitle className={body()}>{article.description}</StyledColumnistTitle>}
          {status === "archive" && (
            <DateBadge type="outline" dateText={dateText} dayText={dayText} />
          )}
          {status === "current" && (
            <DateBadge type="fill" dateText={dateText} dayText={dayText} />
          )}
          {status === "future" && (
            <DateBadge type="gray" dateText={dateText} dayText={dayText} />
          )}
        </a>
      }
    </StyledColumnist>
  );
};

const StyledColumnist = styled("div", {
  width: "226px",
  height: "265px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  margin: "0 auto",
  "@bp4": {
    width: "236px",
  },
  "@bp5": {
    width: "206px",
  },
  "& .link-wrapper": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textDecoration: "none",
    width: "100%",
    height: "100%",
    padding: "32px 16px",
    "&:hover": {
      textDecoration: "none",
    },
    "& a": {
      display: "flex",
      justifyContent: "center",
      textDecoration: "none",
    }
  },
  "& .link-wrapper--active": {
    "&:hover": {
      "@bp5": {
        boxShadow: "0px 0px 8px #99999945",
        transition: "0.3s",
      }
    }
  },
  variants: {
    type: {
      past: {
        background: "$grayscale0",
      },
      active: {
        background: "$grayscale0",
      },
      default: {
        padding: "40px 48px 40px 48px",
        justifyContent: "center",
        height: "292px",
        width: "100%",
        background: "$grayscale0",
        "& p": {
          color: "$grayscale75",
          fontWeight: 600,
          //maxWidth: "204px",
        },
        "@bp4": {
          width: "300px",
          height: "300px",
        },
        "&:hover": {
          boxShadow: "0px 16px 32px 0px #E7E7E7BF",
          cursor: "pointer",
        },
        "& .link-wrapper": {
          padding: "0",
        }
      },
      disabled: {
        "& p": {
          color: "$grayscale75",
        },
      },
    },
    blockStatus: {
      active: {
        background: "$columnistBackground",
      },
      inactive: {
        //pointerEvents: "none",
        background: "$columnistBackground",
        "@bp5": {
          background: "transparent",
        },
        "& p": {
          color: "$grayscale75",
        },
      }
    }
  },
  "& .avatar": {
    width: "100px",
    height: "100px",
    marginBottom: "16px",
    "@bp4": {
      width: "96px",
      height: "96px",
    },
  },
  "& p, h4": {
    margin: 0,
    textAlign: "center",
    color: "$grayscale100",
  },
});

const StyledColumnistTitle = styled("p", {
  margin: "6px 0 16px 0 !important",
  textAlign: "center",
  overflow: "hidden",
  wordBreak: "break-word",
  textOverflow: "ellipsis",
  "-webkit-box-orient": "vertical",
  display: "-webkit-box",
  "-webkit-line-clamp": "3",

  "@bp4": {
    margin: "6px 0 16px 0 !important",
  },
  a: {
    color: "inherit",
  },
});

export default withThemeContext(Columnist);
